<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="mod-joylearning__registeinfo}">
      <!-- :inline="true" -->
      <el-form label-width="auto"
               label-position="left"
               :model="dataForm"
               @keyup.enter.native="getDataList()">
        <el-row class="margb10">
          <!-- 姓名 -->
          <el-col :span="5">
            <el-form-item :label="$t('registe.username')">
              <el-input v-model="dataForm.userName"
                        class="search-item"
                        :placeholder="$t('registe.placeholderName')"></el-input>
            </el-form-item>
          </el-col>
          <!-- 岗位 -->
          <el-col :span="5">
            <el-form-item :label="$t('registe.positionname')" class="search-item">
              <el-select filterable
                         multiple
                         collapse-tags
                         v-model="dataForm.positionName"
                         placeholder="请选择职位">
                <el-option v-for="(item,index) in jobCodeArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 课程名称 -->
          <el-col :span="5">
            <el-form-item :label="$t('registe.coursename')" class="search-item">
              <el-input v-model="dataForm.courseName"
                        :placeholder="$t('registe.placeholderCourseName')"></el-input>
            </el-form-item>
          </el-col>
          <!-- 类型 -->
          <el-col :span="5">
            <el-form-item :label="$t('registe.applyflag')"
                          class="search-item"
                          prop="registApplyFlag">
              <el-select v-model="registApplyFlag"
                         :placeholder="$t('user.select')">
                <el-option label="课程报名"
                           value="10">课程报名</el-option>
                <!-- <el-option v-for="(item,index) in registeApplyFlagArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 查询 -->
          <el-col :span="3"
                  style="float: right">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         @click="getDataListMerge">{{$t('query')}}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <!--查询区第二行 ---->
        <el-row class="margb10">
          <!--开始时间-->
          <el-col :span="5">
            <el-form-item :label="$t('registe.startdate')"
                          class="search-item"
                          prop="dataForm.startDate">
              <el-date-picker v-model="dataForm.startDate"
                              :placeholder="$t('registe.startdate')"
                              type="date"
                              value-format="yyyy-MM-dd"
                              width="210" />
            </el-form-item>
          </el-col>
          <!--结束时间-->
          <el-col :span="5">
            <el-form-item :label="$t('registe.enddate')"
                          class="search-item"
                          prop="dataForm.enddate">
              <el-date-picker v-model="dataForm.endDate"
                              :placeholder="$t('registe.enddate')"
                              type="date"
                              value-format="yyyy-MM-dd"
                              width="210" />
            </el-form-item>
          </el-col>
          <!-- 审批状态 -->
          <el-col :span="5">
            <el-form-item :label="$t('registe.approvalstatus')"
                          class="search-item"
                          prop="approvalstatus">
              <el-select v-model="dataForm.approvalStatus"
                         clearable
                         :placeholder="$t('cert.select')">
                <el-option v-for="(item,index) in registeApprovalStatusArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 重置 -->
          <el-col :span="3"
                  style="float: right">
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         @click="again">{{$t('reset')}}</el-button>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <!-- 表头动态展示(还得改)
      // 类型 applyflag 10 课程报名 20 分配 30 新增开课需求
      // 审批状态 approvalStatus 10 待审核 20 已同意 30 已拒绝 40 已撤销
      -->
      <el-table v-loading="dataListLoading"
                :data="dataList"
                border
                @selection-change="dataListSelectionChangeHandle"
                style="width: 100%;">
        <!--NO.-->
        <!--<el-table-column prop="registeId"-->
        <!--:label="$t('registe.no')"-->
        <!--width="50"-->
        <!--align="center">-->
        <!--</el-table-column>-->
        <!--姓名-->
        <el-table-column prop="userName"
                         :label="$t('registe.username')"
                         header-align="center"
                         align="center"
                         width="80"></el-table-column>
        <!--岗位-->
        <el-table-column prop="positionNameCn"
                         :label="$t('registe.positionname')"
                         header-align="center"
                         align="center"
                         width="80"></el-table-column>
        <!--经销商-->
        <el-table-column prop="orgName"
                         :label="$t('registe.orgname')"
                         header-align="center"
                         align="center"
                         width="180"></el-table-column>
        <!--类型-->
        <el-table-column prop="registApplyFlag"
                         :label="$t('registe.applyflag')"
                         header-align="center"
                         align="center"
                         width="80"></el-table-column>
        <!--课程名称-->
        <el-table-column prop="courseNameCn"
                         :label="$t('registe.coursename')"
                         header-align="center"
                         align="center"
                         width="180"></el-table-column>
        <!--排期名称-->
        <el-table-column prop="offeringName"
                         :label="$t('registe.offeringname')"
                         header-align="center"
                         align="center"
                         width="180"></el-table-column>
        <!--开始时间-->
        <el-table-column prop="startdate"
                         :label="$t('registe.startdate')"
                         header-align="center"
                         align="center"
                         :formatter="dateFormat"></el-table-column>
        <!--结束时间-->
        <el-table-column prop="enddate"
                         :label="$t('registe.enddate')"
                         header-align="center"
                         align="center"
                         :formatter="dateFormat"></el-table-column>
        <!--申请时间-->
        <el-table-column prop="applyDate"
                         :label="$t('registe.applydate')"
                         header-align="center"
                         align="center"
                         :formatter="dateFormat"></el-table-column>
        <!--审批状态-->
        <el-table-column prop="approvalStatus"
                         :label="$t('registe.approvalstatus')"
                         header-align="center"
                         :formatter="registeapprovalstatus"
                         align="center"></el-table-column>
        <!--审批人-->
        <el-table-column prop="approvalUserName"
                         :label="$t('registe.approvalusername')"
                         header-align="center"
                         align="center"></el-table-column>
        <!-- 操作 -->
        <!--<el-table-column :label="$t('handle')"-->
        <!--fixed="right"-->
        <!--align="center"-->
        <!--width="100">-->
        <!--<template slot-scope="scope">-->
        <!--&lt;!&ndash; 撤销理由 &ndash;&gt;-->
        <!--<div>-->
        <!--<el-dropdown-item prop="revokeRemark"-->
        <!--v-if="scope.row.approvalStatus =='40'"-->
        <!--@click.native="viewRemark('revoke',scope.row.revokeRemark)">{{ $t('registe.revokeremark') }}</el-dropdown-item>-->
        <!--&lt;!&ndash; 审批意见 &ndash;&gt;-->
        <!--<el-dropdown-item prop="approvalRemark"-->
        <!--v-if="scope.row.approvalStatus =='30'"-->
        <!--@click.native="viewRemark('approval',scope.row.approvalRemark)">{{ $t('registe.approvalremark') }}</el-dropdown-item>-->
        <!--</div>-->
        <!--&lt;!&ndash; <el-dropdown trigger="click" placement="bottom">-->
        <!--<span class="el-dropdown-link">-->
        <!--{{ $t('handle') }}<em class="el-icon-caret-bottom el-icon&#45;&#45;right"></em>-->
        <!--</span>-->
        <!--<el-dropdown-menu slot="dropdown"> &ndash;&gt;-->
        <!--&lt;!&ndash; 同意 &ndash;&gt;-->
        <!--&lt;!&ndash; <el-dropdown-item v-if="scope.row.approvalStatus =='10'"-->
        <!--@click.native="gotoView('agree', scope.row)"-->
        <!--&gt;{{ $t('registe.agree') }}</el-dropdown-item> &ndash;&gt;-->
        <!--&lt;!&ndash; 拒绝&ndash;&gt;-->
        <!--&lt;!&ndash; <el-dropdown-item v-if="scope.row.approvalStatus =='10'"-->
        <!--@click.native="gotoView('refuse', scope.row)"-->
        <!--&gt;{{ $t('registe.refuse') }}</el-dropdown-item> &ndash;&gt;-->
        <!--&lt;!&ndash; 撤销理由&ndash;&gt;-->
        <!--&lt;!&ndash; <el-dropdown-item v-if="scope.row.approvalStatus =='40'"-->
        <!--@click.native="editRemark('revoke')"-->
        <!--&gt;{{ $t('registe.revokereason') }}</el-dropdown-item> &ndash;&gt;-->
        <!--&lt;!&ndash; 审批意见 &ndash;&gt;-->
        <!--&lt;!&ndash; <el-dropdown-item v-if="scope.row.approvalStatus =='30'"-->
        <!--@click.native="editRemark('approval')"-->
        <!--&gt;{{ $t('registe.opinion') }}</el-dropdown-item> &ndash;&gt;-->
        <!--&lt;!&ndash; 撤销 &ndash;&gt;-->
        <!--&lt;!&ndash; <el-dropdown-item v-if="scope.row.approvalStatus =='20'"-->
        <!--@click.native="gotoView('revoke', scope.row)"-->
        <!--&gt;{{ $t('registe.revoke') }}</el-dropdown-item> &ndash;&gt;-->
        <!--&lt;!&ndash; 替换 &ndash;&gt;-->
        <!--&lt;!&ndash; <el-dropdown-item v-if="scope.row.approvalStatus =='20'"-->
        <!--@click.native="changeUser(scope.row)">{{ $t('registe.change') }}-->
        <!--</el-dropdown-item> &ndash;&gt;-->
        <!--&lt;!&ndash; </el-dropdown-menu>-->
        <!--</el-dropdown> &ndash;&gt;-->
        <!--</template>-->
        <!--</el-table-column>-->
      </el-table>
      <el-pagination :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle"></el-pagination>
      <!-- 编辑弹窗(撤销理由) -->
      <el-dialog :title="$t('registe.revokeremark')"
                 :visible.sync="viewRemarkVisible"
                 width="30%"
                 :data="dataList">
        <el-form :model="form">
          <el-form-item :label="$t('registe.revokeremark')"
                        :label-width="formLabelWidth">
            <el-input class="textarea-input"
                      :disabled="true"
                      v-model="txtrevokeRemark"
                      type="textarea"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="viewRemarkVisible = false">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 编辑弹窗(审核意见) -->
      <el-dialog :title="$t('registe.approvalremark')"
                 :visible.sync="viewApprovalVisible"
                 width="30%">
        <el-form :model="form">
          <el-form-item :label="$t('registe.approvalremark')"
                        :label-width="formLabelWidth">
            <el-input class="textarea-input"
                      :disabled="true"
                      v-model="txtapprovalRemark"
                      type="textarea"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="viewApprovalVisible = false">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 弹窗, 新增 / 修改 -->
      <change-user v-if="ChangeUserVisible"
                   ref="changeUser"
                   @refreshDataList="getDataList"></change-user>
    </div>
  </el-card>
</template>

<script>
  import mixinViewModule from '@/mixins/view-module'
  import changeUser from './registeinfo-user'
  export default {
    mixins: [mixinViewModule],
    dataList: [],
    data () {
      return {
        mixinViewModuleOptions: {
          getDataListIsPage: true,
          // getDataListURL: '/learning/offeringregiste/pageRegiste',
          getDataListURL: '/learning/offeringregiste/pageRegiste',
          updateURL: '/learning/offeringregiste/statusUpdate'
        },
        // 类型
        registeApplyFlagArr: this.enums['registeApplyFlag'],
        // 审批状态
        registeApprovalStatusArr: this.enums['approvalStatus'],
        dataForm: {
          userName: '', // 姓名
          positionName: [], // 岗位
          courseName: '', // 课程名称
          startDate: '', // 开始时间
          endDate: '', // 结束时间
          approvalStatus: '10' // 审批状态
        },
        registApplyFlag: '10', // 类型
        // 等待转圈
        dataListLoading: false,
        isShow: false,
        checkAll: false,
        // 是否显示分配用户
        ChangeUserVisible: false,
        // 是否显示弹窗
        viewRemarkVisible: false, // 撤销理由
        viewApprovalVisible: false, // 审批意见
        //岗位下拉选择
        jobCodeArr: [],
        txtrevokeRemark: '',
        txtapprovalRemark: '',
        formLabelWidth: '80px'

      }
    },
    components: {
      changeUser
    },
    created () {
      this.mixinViewModuleOptions.getDataListURL =
              '/learning/offeringregiste/pageRegiste'
      this.mixinViewModuleOptions.getDataListIsPage = true
      this.getDataList()
      this.queryPosition()
    },
    methods: {
      // 查询
      getDataListMerge () {
        if (this.registApplyFlag === '10') {
          // 查询报名表
          this.mixinViewModuleOptions.getDataListURL =
                  '/learning/offeringregiste/pageRegiste'
        } else if (this.registApplyFlag === '20') {
          // 查询需求表
          this.mixinViewModuleOptions.getDataListURL =
                  '/learning/offeringregiste/pageDemandApply'
        }
        if (this.dataForm.startDate === '' || this.dataForm.startDate === null) {
          this.dataForm.startDate = ''
        }
        if (this.dataForm.endDate === '' || this.dataForm.endDate === null) {
          this.dataForm.endDate = ''
        }
        this.getDataList()
      },
      // 获取数据列表
      getDataList () {
        console.info(this.dataForm)
        let jobCodes = ''
        for (let i = 0; i < this.dataForm.positionName.length; i++) {
          if (jobCodes === '') {
            jobCodes = this.dataForm.positionName[i]
          } else {
            jobCodes = jobCodes + ',' + this.dataForm.positionName[i]
          }
        }
        if (this.brandQuery != null || this.brandQuery !== '') {
          this.dataForm.courseBrand = this.brandQuery + ''
        }
        let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
        if ('regionIds' in newDataForm) {
          if (newDataForm.regionIds.length === 0) {
            newDataForm.regionIds = ''
          } else {
            newDataForm.regionIds = newDataForm.regionIds.join(',')
          }
        }
        this.dataListLoading = true
        this.$request.get(
                this.mixinViewModuleOptions.getDataListURL,
                {
                  order: this.order,
                  orderField: this.orderField,
                  jobCodes: jobCodes,
                  page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
                  limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
                  ...newDataForm
                }
        ).then((res, total, code, data) => {
          console.warn(data.result)
          this.dataListLoading = false
          let resultList = data.data.records
          this.dataList = resultList
          this.total = this.mixinViewModuleOptions.getDataListIsPage ? parseInt(data.data.total, 10) : 0
          // 延迟加载
          this.$nextTick(() => {
            this.querSelect()
          })
        }).catch(() => {
          this.dataListLoading = false
        })
      },
      // 替换
      changeUser (row) {
        this.ChangeUserVisible = true
        this.$nextTick(() => {
          this.$refs.changeUser.registeId = row.registeId
          // 赋值初始化
          this.$refs.changeUser.init()
        })
      },
      // 日期格式
      dateFormat (row, column, cellValue) {
        var datetime = cellValue
        if (datetime) {
          datetime = new Date(datetime)
          let y = datetime.getFullYear() + '-'
          let mon = datetime.getMonth() + 1 + '-'
          let d = datetime.getDate()
          return y + mon + d
        }
        return ''
      },
      // 重置
      again () {
        this.showVehicleClassList = ''
        this.dataForm = {
          userName: '', // 姓名
          positionName: [], // 岗位
          courseName: '', // 课程名称
          startDate: '', // 开始时间
          endDate: '', // 结束时间
          approvalStatus: '10' // 审批状态
        }
        this.registApplyFlag = '10'
        this.mixinViewModuleOptions.getDataListURL =
                '/learning/offeringregiste/pageRegiste'
        this.getDataList()
      },
      // 操作列下拉选项
      /* gotoView (type, id) {
        if (type === 'agree') {
          // 更新审批状态-同意
          this.updateRegiste(id, '20')
        } else if (type === 'refuse') {
          // 更新审批状态-拒绝
          this.updateRegiste(id, '30')
        } else if (type === 'revoke') {
          // 更新审批状态-撤销
          this.updateRegiste(id, '40')
        } else if (type === 'change') {
          // 弹出替换人员选择窗口
          this.selectUser(id)
        }
      }, */
      // 更新
      /* updateRegiste (row, type) {
        this.$request
          .post(this.mixinViewModuleOptions.updateURL, {
            registeId: row.registeId,
            approvalStatus: type
          })
          .then(res => {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.getDataList()
              }
            })
          })
          .catch(() => {})
      }, */
      // 更新审批意见
      viewRemark (type, strremark) {
        if (type === 'revoke') {
          // 撤销理由
          this.viewRemarkVisible = true
          this.txtrevokeRemark = strremark
        } else if (type === 'approval') {
          // 审批意见
          this.viewApprovalVisible = true
          this.txtapprovalRemark = strremark
        }
      },
      /* updateRemark (type) {
        if (type === 'revoke') {
          this.editRemarkVisible = false
        } else if (type === 'approval') {
          this.editApprovalVisible = false
        }
      }, */
      registeapplyflag (row, column, cellValue) {
        if (cellValue === '10') {
          return '课程报名'
        } else if (cellValue === '20') {
          return '分配'
        } else if (cellValue === '30') {
          return '新增开课需求'
        } else { return ' ' }
      },
      registeapprovalstatus (row, column, cellValue) {
        if (cellValue === '10') {
          return '待审核'
        } else if (cellValue === '20') {
          return '已同意'
        } else if (cellValue === '30') {
          return '已拒绝'
        } else if (cellValue === '40') {
          return '已撤销'
        } else { return ' ' }
      },
      // 查询岗位信息
      queryPosition () {
        this.$request.get('/talent/position/queryCommPosition', {}).then((res, total, code, data) => {
          this.jobCodeArr = data.data
        }).catch((error) => {
          console.error(error)
        })
      }
    }
  }
</script>
<style scoped>
  .el-date-editor.el-input.el-date-picker {
    width: 110px;
  }
  .dialog-footer {
    margin: 10px;
    padding-bottom: 20px !important;
  }
  .textarea-input {
    width: 450px;
  }
   .search-item .el-form-item__content {
    margin-left: 68px !important;
  }
</style>
